module.exports = __webpack_public_path__ + "static/media/telephone.24653c84.svg";